import floorFigure from "../../../configs/floorFigure"
import {
  checkForEmpty,
  checkForLengthAfterDot,
  checkOnlyDot,
  checkRegEx,
  checkStartWithDot,
} from "../../../helpers/checkers"
import { regexes } from "../../../helpers/regex"
import {
  Currencies,
  Notifications,
} from '@orbital/games-frontend-library'

export const handleBlur = (
  e: any,
  minbet: number,
  maxbet: number,
  prec: number,
  handleStake: any,
  setStakeValue: any,
  stakeValue: any,
  handleNotification: any,
  currency: any
) => {
  const value = e.target.value
  if (checkForEmpty(value) || checkOnlyDot(value)) {
    return (
      handleStake((+minbet).toFixed(prec)),
      setStakeValue((+minbet).toFixed(prec))
    )
  }
  if (value > maxbet) {
    return (
      handleStake((+maxbet).toFixed(prec)),
      setStakeValue((+maxbet).toFixed(prec)),
      prec &&
      handleNotification(
        Notifications.maxStake +
        Number(maxbet).toFixed(prec) +
        Currencies[currency],
      )
    )
  }
  if (value < minbet) {
    return (
      handleStake((+minbet).toFixed(prec)),
      setStakeValue((+minbet).toFixed(prec)),
      prec && handleNotification(
        Notifications.minStake +
        Number(minbet).toFixed(prec) +
        Currencies[currency],
      )
    )
  }
  if (checkStartWithDot(value)) {
    if (checkForLengthAfterDot(value, prec)) {
      return (
        handleStake(floorFigure(stakeValue, prec)),
        setStakeValue(floorFigure(stakeValue, prec))
      )
    } else {
      return handleStake("0" + value), setStakeValue("0" + value)
    }
  }
  if (checkRegEx(value, regexes.onlyZeroes)) {
    return (
      handleStake((+minbet).toFixed(prec)),
      setStakeValue((+minbet).toFixed(prec))
    )
  }
  if (checkForLengthAfterDot(value, prec)) {
    return (
      handleStake(floorFigure(stakeValue, prec)),
      setStakeValue(floorFigure(stakeValue, prec))
    )
  }
  return (
    handleStake(floorFigure(value, prec)),
    setStakeValue(floorFigure(value, prec))
  )
}

// export const handleChange = (e: any, setStakeValue: any) => {
//   const value = e.target.value
//   if (checkRegEx(value, regexes.numbersDotComma)) {
//     setStakeValue(value.replace(/,/g, "."))
//   }
// }


export const handleChange = (e: any, setStakeValue: any, prec: number) => {
  const value = e.target.value;
  if (checkRegEx(value, regexes.numbersDotComma)) {
    // Replace commas with periods in the whole value
    let modifiedValue = value.replace(/,/g, ".");

    // Split the value into integer and decimal parts
    const [integerPart, decimalPart] = modifiedValue.split(".");

    // Limit the number of decimal places based on the `prec` parameter
    if (prec >= 0) {
      if (decimalPart) {
        modifiedValue = `${integerPart}.${decimalPart.slice(0, prec)}`;
      }
    }
    setStakeValue(modifiedValue);
  }
};